<template>
    <v-list class="fill-height-subtracted" density="compact" lines="two">
        <v-virtual-scroll class="fill-height" v-if="combined_list.length != 0" width="400" :items="combined_list" :item-height="56" renderless>
            <template v-slot:default="{ index, item }">
                <ListItemMultipanelGroup v-if="item.is_group" :group="item.group" :key="'g:' + item.uuid" />
                <ListItemConstructible v-else :level="item.level" :constructible="item" :key="item.uuid" />
            </template>
        </v-virtual-scroll>
        <v-list-subheader v-else>
            {{ t(`no_${level}_for_this_station`) }}
        </v-list-subheader>
    </v-list>
</template>

<style lang="scss" scoped>
.fill-height-subtracted {
    height: calc(100% - 20px);
}
</style>


<script>
import ListItemConstructible from './ListItemConstructible.vue';
import ListItemMultipanelGroup from './ListItemMultipanelGroup.vue';
import { useConstructiblesStore } from "@/stores/constructibles";
import { useSessionStore } from "@/stores/session";
import { usePitStoreBasics } from "@/stores/app_common";

export default {
    setup() {
        const constructibles_store = useConstructiblesStore();
        const session_store = useSessionStore();
        const store_basics = usePitStoreBasics();

        return {
            ...store_basics,
            constructibles_store,
            session_store,
        };
    },
    components: {
        ListItemConstructible,
        ListItemMultipanelGroup,
    },
    props: ["level"],
    computed: {
        first() {
            return this.constructibles_store.myFirst();
        },
        my_list() {
            return this.constructibles_store.myList();
        },
        m_multipanel() {
            return this.session_store.hasAnyModule(['m_multipanel'])
        },
        // Group rows live alongside the per-panel rows; each is rendered with its
        // own list-item component.
        group_rows() {
            if (!this.m_multipanel) return []
            const groups = this.constructibles_store.multipanel_groups || []
            return groups.map(g => ({ is_group: true, uuid: g.uuid, group: g }))
        },
        combined_list() {
            if (this.group_rows.length === 0) return this.my_list

            // For each group, find its anchor: the earliest-position member that
            // is actually present in my_list. Insert the group row right before
            // that member. Orphan groups (no member in my_list) are appended.
            const my_uuids = new Set(this.my_list.map(c => c.uuid))
            const anchorToGroups = new Map()
            const orphan_groups = []
            for (const gr of this.group_rows) {
                const sorted = [...(gr.group.memberships || [])]
                    .sort((a, b) => (a.position || 0) - (b.position || 0))
                const anchor = sorted.find(m => my_uuids.has(m.assembly))
                if (anchor) {
                    const list = anchorToGroups.get(anchor.assembly) || []
                    list.push(gr)
                    anchorToGroups.set(anchor.assembly, list)
                } else {
                    orphan_groups.push(gr)
                }
            }

            const out = []
            for (const item of this.my_list) {
                const groups_here = anchorToGroups.get(item.uuid)
                if (groups_here) for (const gr of groups_here) out.push(gr)
                out.push(item)
            }
            for (const gr of orphan_groups) out.push(gr)
            return out
        },
    },
}
</script>
